// ./router.js
import React from "react";
import { Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

import "./assets/style/style.scss";
import "../src/assets/style/color.scss";
import "../src/assets/style/custome.scss";
import "../src/assets/style/fonts.scss";
import "../src/assets/style/height.scss";
import "../src/assets/style/responsive.scss";
import "../src/assets/style/width.scss";
import Login from "./Screen/Auth/Login/Login";
import Layout from "./Screen/Layout/Layout";
import Dashboard from "./Screen/Dashboard/Dashboard";
import Roles from "./Screen/Roles/Roles";
import RolesAdd from "./Screen/Roles/RolesAdd";
import SuperAdmin from "./Screen/HO/SuperAdmin/SuperAdmin";
import SuperAdminAdd from "./Screen/HO/SuperAdmin/SuperAdminAdd";
import Inventory from "./Screen/HO/Inventory/Inventory";
import InventoryAdd from "./Screen/HO/Inventory/InventoryAdd";
import Technical from "./Screen/HO/Technical/Technical";
import TechnicalAdd from "./Screen/HO/Technical/TechnicalAdd";
import RegionalManager from "./Screen/RegionalManager/RegionalManager";
import RegionalAdd from "./Screen/RegionalManager/RegionalAdd";
import ServiceEngineer from "./Screen/ServiceEngineer/ServiceEngineer";
import ServiceAdd from "./Screen/ServiceEngineer/ServiceAdd";
import Customer from "./Screen/Customer/Customer";
import Region from "./Screen/Master/Region/Region";
import RegionAdd from "./Screen/Master/Region/RegionAdd";
import FaultType from "./Screen/Master/Fault/FaultType";
import FaultAdd from "./Screen/Master/Fault/FaultAdd";
import SpareType from "./Screen/Master/SpareType/SpareType";
import SpareAdd from "./Screen/Master/SpareType/SpareAdd";
import Support from "./Screen/Master/Support/Support";
import NewTicket from "./Screen/Ticket/NewTicket/NewTicket";
import NewTicketView from "./Screen/Ticket/NewTicket/NewTicketView";
import Pending from "./Screen/Ticket/Pending/Pending";
import PendingTable from "./Screen/Ticket/Pending/PendingTable";
import PendingView from "./Screen/Ticket/Pending/PendingView";
import PendingMove from "./Screen/Ticket/Pending/PendingMove";
import InventoryTable from "./Screen/Ticket/Inventory/InventoryTable";
import InventoryView from "./Screen/Ticket/Inventory/InventoryView";
import TechnicalTable from "./Screen/Ticket/Technical/TechnicalTable";
import TechnicalView from "./Screen/Ticket/Technical/TechnicalView";
import InventoryMove from "./Screen/Ticket/Inventory/InventoryMove";
import TechnicalMove from "./Screen/Ticket/Technical/TechnicalMove";
import NextVisitView from "./Screen/Ticket/NextVisit/NextVisitView";
import NextMove from "./Screen/Ticket/NextVisit/NextMove";
import NextVisit from "./Screen/Ticket/NextVisit/NextVisit";
import ServiceTable from "./Screen/Ticket/service/ServiceTable";
import ServiceView from "./Screen/Ticket/service/ServiceView";
import ServiceMove from "./Screen/Ticket/service/ServiceMove";
import WorkView from "./Screen/Ticket/WorkClosed/WorkView";
import WorkMove from "./Screen/Ticket/WorkClosed/WorkMove";
import ClosedTable from "./Screen/Ticket/Closed/ClosedTable";
import ClosedView from "./Screen/Ticket/Closed/ClosedView";
import ClosedMove from "./Screen/Ticket/Closed/ClosedMove";
import WorkClosed from "./Screen/Ticket/WorkClosed/WorkClosed";
import Dashboard1 from "./Screen/Screen2/Dashboard/Dashboard1";
import Layout1 from "./Screen/Layout/Layout1";
import Pending2 from "./Screen/Screen2/InventoryTicket/Pending2";
import ViewInventory from "./Screen/Screen2/InventoryTicket/ViewInventory";
import TableInventory from "./Screen/Screen2/InventoryTicket/Inventory";
import DispatchTable from "./Screen/Screen2/Dispatch/DispatchTable";
import DispatchView from "./Screen/Screen2/Dispatch/DispatchView";
import DeliveryTable from "./Screen/Screen2/Delivery/DeliveryTable";
import DeliveryView from "./Screen/Screen2/Delivery/DeliveryView";
import ViewTechnical from "./Screen/Screen2/TechnicalSupport/ViewTechnical";
import TableTechnical from "./Screen/Screen2/TechnicalSupport/TableTechnical";
import WorkTable from "./Screen/Screen2/WorkCompleted/WorkTable";
import WorkCompletedView from "./Screen/Screen2/WorkCompleted/WorKCompletedView";
import TicketClosedTable from "./Screen/Screen2/TickedClosed/TicketClosedTable";
import TicketClosedView from "./Screen/Screen2/TickedClosed/TickedClosedView";
import HttpClient from "./Screen/redux/api/HttpClient";
import PrivateRoutes from "./PrivateRoute/PrivateRoutes";
import SupportAdd from "./Screen/Master/Support/SupportAdd";
import CustomerPrinters from "./Screen/Customer/CustomerPrinters";
import ViewDispatch from "./Screen/Screen2/InventoryTicket/ViewDispatch";
import ViewDelivered from "./Screen/Screen2/InventoryTicket/ViewDelivered";

const AppRoutes = () => {
  const token = localStorage.getItem("token");
  if (token) {
    HttpClient.defaults.headers.common["Authorization"] =
      `Bearer ${token}` || "";
  }
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route element={<PrivateRoutes />}>
        <Route element={<Layout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/roles" element={<Roles />} />
          <Route path="/roles-add" element={<RolesAdd />} />
          <Route path="/super-admin" element={<SuperAdmin />} />
          <Route path="/super-admin-add" element={<SuperAdminAdd />} />
          <Route path="/inventory" element={<Inventory />} />
          <Route path="/inventory-add" element={<InventoryAdd />} />
          <Route path="/technical" element={<Technical />} />
          <Route path="/technical-add" element={<TechnicalAdd />} />
          <Route path="/regional-manager" element={<RegionalManager />} />
          <Route path="/regional-add" element={<RegionalAdd />} />
          <Route path="/service-engineer" element={<ServiceEngineer />} />
          <Route path="/service-add" element={<ServiceAdd />} />
          <Route path="/customer" element={<Customer />} />
          <Route path="/customer-printers" element={<CustomerPrinters />} />
          <Route path="/region" element={<Region />} />
          <Route path="/region-add" element={<RegionAdd />} />
          <Route path="/fault-type" element={<FaultType />} />
          <Route path="/fault-add" element={<FaultAdd />} />
          <Route path="/spare-type" element={<SpareType />} />
          <Route path="/spare-add" element={<SpareAdd />} />
          <Route path="/support" element={<Support />} />
          <Route path="/support-add" element={<SupportAdd />} />
          <Route path="/new-ticket" element={<NewTicket />} />
          <Route path="/new-ticket-view" element={<NewTicketView />} />
          <Route path="/pending" element={<Pending />} />
          <Route path="/pending-table" element={<PendingTable />} />
          <Route path="/pending-view" element={<PendingView />} />
          <Route path="/pending-move" element={<PendingMove />} />
          <Route path="/inventory-table" element={<InventoryTable />} />
          <Route path="/inventory-view" element={<InventoryView />} />
          <Route path="/inventory-move" element={<InventoryMove />} />
          <Route path="/technical-table" element={<TechnicalTable />} />
          <Route path="/technical-view" element={<TechnicalView />} />
          <Route path="/technical-move" element={<TechnicalMove />} />
          <Route path="/next-visit" element={<NextVisit />} />
          <Route path="/next-visit-view" element={<NextVisitView />} />
          <Route path="/next-move" element={<NextMove />} />
          <Route path="/service-table" element={<ServiceTable />} />
          <Route path="/service-view" element={<ServiceView />} />
          <Route path="/service-move" element={<ServiceMove />} />
          <Route path="/Work-closed" element={<WorkClosed />} />
          <Route path="/Work-view" element={<WorkView />} />
          <Route path="/Work-move" element={<WorkMove />} />
          <Route path="/closed-table" element={<ClosedTable />} />
          <Route path="/closed-view" element={<ClosedView />} />
          <Route path="/closed-move" element={<ClosedMove />} />
        </Route>
        <Route element={<Layout1 />}>
          <Route path="/dashboard1" element={<Dashboard1 />} />
          <Route path="/Pending2" element={<Pending2 />} />
          <Route path="/table-inventory" element={<TableInventory />} />
          <Route path="/view-inventory" element={<ViewInventory />} />
          <Route path="/view-dispatch" element={<ViewDispatch />} />
          <Route path="/dispatch-table" element={<DispatchTable />} />
          {/* <Route path="/dispatch-view" element={<DispatchView />} /> */}

          <Route path="/delivery-table" element={<DeliveryTable />} />
          <Route path="/delivery-view" element={<ViewDelivered />} />
          {/* <Route path="/delivery-view" element={<DeliveryView />} /> */}
          {/* <Route path="/view-technical" element={<ViewTechnical />} /> */}
          <Route path="/table-technical" element={<TableTechnical />} />

          <Route path="/Work-completed-table" element={<WorkTable />} />
          <Route path="/Work-completed-view" element={<WorkCompletedView />} />

          <Route path="/ticket-closed-table" element={<TicketClosedTable />} />
          <Route path="/ticket-closed-view" element={<TicketClosedView />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default AppRoutes;
